import React, { useEffect, useRef, useState } from "react";
import { useSendToVoicemailAction } from "../../hooks/useCallAction";
import SendToVoicemailUI from "./SendToVoicemailUI";
import { useRouteConfigModals } from "../contexts/RouteConfigModalsContext";

/**
 * SendToVoicemail component - can be used for root or off-hours contexts
 * @param {string} context - 'root' | 'offHours' (defaults to 'root')
 */
const SendToVoicemail = ({ 
  setOpenConfigureSlotModal, 
  route, 
  setRoute,
  context = 'root',
  hasValidationError = false,
}) => {
  const routeModals = useRouteConfigModals();
  const [localRecordings] = useState(
    () => JSON.parse(localStorage.getItem("organization"))?.recordings?.L || []
  );
  const recordings = routeModals?.recordings ?? localRecordings;
  const sendToVoicemailLogic = useSendToVoicemailAction(context, route, setRoute);
  const addRecordingOption = routeModals
    ? { label: "Add Recording", onClick: () => routeModals.openAddRecordingModal(sendToVoicemailLogic.handleRecordingChange) }
    : undefined;
  const refreshedRecIdRef = useRef(null);

  // If the draft set a recording id that isn't in the dropdown yet, refresh from storage
  // (at most once per id — refresh always yields a new array, which would otherwise loop)
  useEffect(() => {
    const recId =
      context === "offHours" ? route?.offHoursRecording : route?.primaryRecording;
    if (!recId || !routeModals?.refreshRecordings) return;
    const found = recordings?.some((r) => (r.M?.rec_id?.S ?? r.rec_id) === recId);
    if (found) {
      refreshedRecIdRef.current = null;
      return;
    }
    if (refreshedRecIdRef.current === recId) return;
    refreshedRecIdRef.current = recId;
    routeModals.refreshRecordings();
  }, [
    context,
    route?.primaryRecording,
    route?.offHoursRecording,
    recordings,
    routeModals?.refreshRecordings,
  ]);

  return (
    <SendToVoicemailUI
      {...sendToVoicemailLogic}
      setOpenConfigureSlotModal={setOpenConfigureSlotModal}
      recordings={recordings}
      hasValidationError={hasValidationError}
      addRecordingOption={addRecordingOption}
    />
  );
};

export default SendToVoicemail;
